import React from 'react'
import { Modal, Image } from 'antd'
import { vehicleDetialModel } from './vehicleDetailModel'
import { getBaseImgLookUrl } from '@/utils/constants'

const ImgModal = ({ modalData }) => {
    const getVehicleDetailModel = () => vehicleDetialModel()
    const { imgVisible, setImgVisible } = getVehicleDetailModel()

    return (
        <Modal
            width={1000}
            bodyStyle={{ height: 660, overflowY: 'auto' }}
            onCancel={() => {
                setImgVisible(false)
            }}
            open={imgVisible}
            title="必传项图片查看"
            footer={null}
        >
            <div>
                <Image.PreviewGroup>
                    {modalData?.map((e) => (
                        <Image src={getBaseImgLookUrl(e.md5)} width={90} style={{ height: '100%', padding: '2px 2px' }} />
                    ))}
                </Image.PreviewGroup>
            </div>
        </Modal>
    )
}

export default ImgModal
